module.exports = __webpack_public_path__ + "img/chanpinBanner.64bfb473.png";